module.exports = __webpack_public_path__ + "img/tabIcHomeOff.8744a817.svg";